module.exports = __webpack_public_path__ + "img/redo_select.fd08e934.svg";